<div class="upload-wrapper">
  <div [hidden]="config?.showPreview !== true" id="content-preview" class="ion-text-center">
    <app-content-preview #viewer [files]="files" [viewHeight]="config?.previewHeight" [allowRemove]="config?.allowRemove"
      (fileRemoved)="removeFile($event)" [uploadTitle]="config?.uploadTitle" [showThumbnails]="config?.showThumbnails"
      [thumbSize]="config?.thumbSize">
    </app-content-preview>
  </div>
  <input type="file" [id]="id" class="fileInput" hidden="true" [accept]="config?.acceptedTypes"
    (change)="selectFile($event)" class="upload" />
  <input type="file" [id]="id + 'v'" class="fileInput" hidden="true" accept="video/*" capture="environment"
    (change)="selectFile($event)" class="upload" />
  <ion-item lines="none" *ngIf="lastFile.path != null && config?.showPreview !== true">
    <ion-label class="ion-text-wrap">
      <p class="ion-text-center">{{lastFile.filename}}</p>
    </ion-label>
    <ion-icon slot="end" name="close-circle-outline" (click)="removeFile(this.lastFile)"></ion-icon>
  </ion-item>
</div>

<ion-tab-bar *ngIf="filesRemaining > 0 || config?.allowChange">

  <ion-tab-button (click)="triggerBrowse()">
    <ion-icon name="attach-outline"></ion-icon>
    <ion-label>Browse</ion-label>
  </ion-tab-button>

</ion-tab-bar>